import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Radio as RadioAppkit } from '@pwc/appkit-react/lib/Radio';

import ErrorMessage from '../select/errorMessage.component';
import { SelectValuePropTypes, SelectOptionPropTypes, FormikPropTypes } from '../propTypes';

const noop = () => null;

const RadioFormik = ({
  label,
  name,
  formik,
  value,
  options,
  hidden = false,
  handleExternalChange = false,
  horizontal = false,
  onAfterChange = noop,
  ...rest
}) => {
  const handleChange = useCallback(event => {
    formik.setFieldValue(name, event.target.value);
    onAfterChange(value, { formik });
  }, [name, formik, onAfterChange, value]);

  useEffect(() => {
    if (handleExternalChange) {
      formik.setFieldValue(name, value);
    }
  }, [name, value, handleExternalChange]); // eslint-disable-line react-hooks/exhaustive-deps

  if (hidden) {
    return null;
  }

  const classNames = classnames([
    'radio-formik-wrapper',
    {
      horizontal,
    },
  ]);

  return (
    <>
      <div className={classNames}>
        {label ? <label className="a-form-label">{label}</label> : null}
        <div className="radio-formik-options">
          {options.map(option => (
            <RadioAppkit
              key={`${option.value}`}
              checked={value === option.value}
              name={name}
              type="radio"
              value={option.value}
              onChange={handleChange}
              {...rest}
            >
              {option.label}
            </RadioAppkit>
          ))}
        </div>
      </div>
      <div className="invalid-feedback">
        <ErrorMessage name={name} formik={formik} />
      </div>
    </>
  );
};

RadioFormik.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string.isRequired,
  formik: FormikPropTypes.isRequired,
  value: SelectValuePropTypes,
  hidden: PropTypes.bool,
  options: PropTypes.arrayOf(SelectOptionPropTypes).isRequired,
  handleExternalChange: PropTypes.bool,
  horizontal: PropTypes.bool,
  onAfterChange: PropTypes.func,
};

export default RadioFormik;
